import { render, staticRenderFns } from "./OnlineUsers.vue?vue&type=template&id=40e08a46"
import script from "./OnlineUsers.vue?vue&type=script&lang=js"
export * from "./OnlineUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports